import { SetAQuestion } from './SetAQuestion';
export default SetAQuestion;
